import React from 'react'
import { browserHistory } from 'react-router';

// An anchor which takes a url as a prop ("to") and triggers a route change

export default function RouterLink(props) {
  const { to, children, className, trackingSrc } = props;

  function handleClick(e) {
    e.preventDefault();
    browserHistory.push(to);
    trackLinkClick();
  }

  function trackLinkClick() {
    window.dataLayer.push({
      'event': 'event_view_link_clicked',
      'destination_url': to,
      'tracking_src': trackingSrc || "not-defined"
    });
  }

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/router-link.es6